import styled from "styled-components"

const YearFilter = styled.div`
  cursor: pointer;
  color: ${(props) =>
    props.active === true
      ? props.theme.b_color_gradients.b_dark
      : props.theme.a_color_gradients.a_dark};
`

const MonthFilter = styled.p`
  color: ${(props) =>
    props.active === true
      ? props.theme.b_color_gradients.b_dark
      : props.theme.a_color_gradients.a_dark};
`

export { YearFilter, MonthFilter }
